<template>
    <aside class="sidebar" :class="{ 'open': $store.state.sidebarOpen }">
      <div class="sidebar-inner">
        <div v-for="(section, index) in $store.state.docStructure" :key="index" class="sidebar-section">
          <h3 class="section-title">{{ section.title }}</h3>
          <ul class="nav-links">
            <li v-for="doc in section.children" :key="doc.slug">
              <router-link :to="`/docs/${doc.slug}`" @click="$store.commit('closeSidebar')">
                {{ doc.title }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  </template>
  
  <style scoped>
  .sidebar {
    width: var(--sidebar-width);
    background: #f8f9fa;
    border-right: 1px solid #eee;
    height: 100%;
    position: fixed;
    left: 0;
    top: var(--header-height);
    bottom: 0;
    overflow-y: auto;
    transition: transform 0.3s;
  }
  
  .sidebar-inner {
    padding: 20px;
  }
  
  .sidebar-section {
    margin-bottom: 30px;
  }
  
  .section-title {
    font-size: 1rem;
    text-transform: uppercase;
    color: #6c757d;
    margin-bottom: 10px;
    font-weight: 600;
  }
  
  .nav-links {
    list-style: none;
  }
  
  .nav-links li {
    margin-bottom: 5px;
  }
  
  .nav-links a {
    display: block;
    padding: 8px 15px;
    color: var(--text-color);
    text-decoration: none;
    border-radius: 4px;
    transition: background 0.2s;
  }
  
  .nav-links a:hover {
    background: rgba(0, 0, 0, 0.05);
  }
  
  .nav-links a.router-link-active {
    color: var(--primary-color);
    background: rgba(52, 152, 219, 0.1);
    font-weight: 500;
  }
  
  @media (max-width: 768px) {
    .sidebar {
      transform: translateX(-100%);
      z-index: 99;
    }
    
    .sidebar.open {
      transform: translateX(0);
    }
  }
  </style>
  